<template>
	<div class="other_backstage">
		<div class="more_back_wrap"></div>
	</div>
</template>

<script>
import env from '@/config';

export default {
	data() {
		return {
			more: null,
		};
	},
	mounted() {
		// 这里加延时是因为切换企业的时候会重绘这个dom，不加延时导致获取位置是错误的，略坑爹
		setTimeout(() => {
			this.init();
		}, 100);
	},
	methods: {
		init() {
			if (!this.$el.querySelector('.more_back_wrap')) {
				// 防止加载缓慢导致未初始化
				setTimeout(() => {
					this.init();
				}, 500);
				return;
			}
			const rect = this.$el.querySelector('.more_back_wrap').getBoundingClientRect();
			if (rect.top === 0 && rect.left === 0 && rect.bottom === 0 && rect.right === 0) {
				// 说明当前未初始化
				setTimeout(() => {
					this.init();
				}, 500);
				return;
			}
			System.import('more-product').then((MoreProduct) => {
				this.more = new MoreProduct({
					el: this.$el.querySelector('.more_back_wrap'),
					key: env.key,
					showArrow: false,
				});
			});
		},
	},
};
</script>

<style lang="less">
.other_backstage {
	margin: 0;
	cursor: pointer;
	margin-right: 24px;
	.more_back_wrap {
		width: 32px;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
.other_drop.el-dropdown-menu {
	width: 248px;
	padding: 15px;
	.el-dropdown-menu__item {
		padding: 0;
		&.stage_back {
			.stage_title {
				font-size: 14px;
				color: #86909c;
			}
			.stage_back {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				width: 100%;
				.stage_square {
					width: 30%;
					height: 75px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					flex-shrink: 0;
					padding: 4px 0;
					.stage_icon {
						height: 37px;
						img {
							width: 37px;
							height: 37px;
						}
					}
					.stage_name {
						font-size: 12px;
						color: #86909c;
						line-height: 17px;
						margin-top: 7px;
					}
					&:hover {
						background-color: #f4f7fa;
						border-radius: 2px;
					}
				}
			}
			&:hover {
				background-color: #fff;
			}
		}
	}
}
</style>
